export interface RenkoBoxSizeUnitOption {
  title: string;
  sharpCharts2Id: string;
  defaultRenkoBoxSize: string;
};

export const RENKO_BOX_SIZE_UNIT_OPTION_POINTS: RenkoBoxSizeUnitOption = {
  title: 'Points',
  sharpCharts2Id: 'point',
  defaultRenkoBoxSize: '1'
};

export const RENKO_BOX_SIZE_UNIT_OPTION_ATR: RenkoBoxSizeUnitOption = {
  title: 'ATR',
  sharpCharts2Id: 'atr',
  defaultRenkoBoxSize: '14'
};

export const DEFAULT_RENKO_BOX_SIZE_UNIT_OPTION: RenkoBoxSizeUnitOption = RENKO_BOX_SIZE_UNIT_OPTION_ATR;

export const RENKO_BOX_SIZE_UNIT_OPTIONS_ARRAY: RenkoBoxSizeUnitOption[] = [
  RENKO_BOX_SIZE_UNIT_OPTION_POINTS,
  RENKO_BOX_SIZE_UNIT_OPTION_ATR
];
